import { equals } from 'ramda'
import { useEffect, useState } from 'react'

import { FaqState } from '../contexts/FaqRoutingContext'

interface SearchLocation {
  search: string
  state?: FaqState | null
}

/**
 * 検索ページの q / page を URL と location.state から同期する
 */
export function useSearchPageState(location: SearchLocation) {
  const [q, setQ] = useState(location.state?.q || [])
  const [page, setPage] = useState(location.state?.page || 1)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const qParam = searchParams.get('q')
    const pageParam = searchParams.get('page')

    const newQ = qParam ? qParam.split(' ') : []
    const newPage = pageParam ? parseInt(pageParam, 10) : 1
    const stateQ = location.state?.q
    const statePage = location.state?.page

    setQ(prevQ => (equals(newQ, prevQ) ? prevQ : newQ))
    setPage(prevPage => (newPage === prevPage ? prevPage : newPage))

    if (stateQ) {
      setQ(prevQ => (equals(stateQ, prevQ) ? prevQ : stateQ))
    }
    if (statePage) {
      setPage(prevPage => (statePage === prevPage ? prevPage : statePage))
    }
  }, [location.search, location.state])

  return {
    q,
    page,
    setQ,
    setPage,
  }
}
